<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Cập nhật Đề thi: {{ modelData.name }}</h2>
        <el-button @click="backModel" size="small" class="btn-back">
          Trờ về <!-- : {{ configData.course.name | courseName }} / {{ configData.chapter.name | chapterName }} -->
        </el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="24">
          <el-form label-position="top" :rules="rules" :model="modelData" ref="createModel" @submit.native.prevent>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item prop="type_time" label="Kiểu đề thi" class="form-item">
                      <el-select v-model="modelData.type_time" filterable placeholder="Kiểu đề thi" class="input-select">
                        <el-option
                          v-for="item in lists.listTypeTime"
                          :key="item.key"
                          :label="item.value"
                          :value="item.key">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item prop="time" label="Thời gian thi" class="form-item">
                      <el-input v-model="modelData.time" class="input-seach">
                        <template slot="append">{{ modelData.time }} phút</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="type_question" label="Loại đề thi" class="form-item">
                      <el-select v-model="modelData.type_question" filterable placeholder="Loại đề thi" class="input-select">
                        <el-option
                          v-for="item in lists.listTypeQuesition"
                          :key="item.key"
                          :label="item.value"
                          :value="item.key">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item prop="score_success" label="Điểm đạt (Điểm số cần đặt để qua đề thi)" class="form-item">
                      <el-select v-model="modelData.score_success" filterable placeholder="Kiểu đề thi" class="input-select">
                        <el-option
                          v-for="item in lists.listScoreSuccess"
                          :key="item.key"
                          :label="item.value"
                          :value="item.key">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item prop="name" label="Tên đề thi" class="form-item">
                  <el-input v-model="modelData.name" class="input-seach" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="Kích hoạt" prop="status">
              <el-switch
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                v-model="modelData.status">
              </el-switch>
            </el-form-item>
            <el-form-item>
              <el-button
                :disable="!canSubmit"
                :loading="!canSubmit"
                type="warning"
                size="small"
                @click="submitForm('createModel')">Cập nhật</el-button>
              <el-button
                size="small"
                class="btn-back"
                @click="backModel">Trở về
              </el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions } from 'vuex'
import tinymce from 'vue-tinymce-editor'
export default {
  name: 'TestKitCreate',
  metaInfo () {
    return {
      title: 'Đề thi'
    }
  },
  components: {
    tinymce
  },
  data () {
    return {
      canSubmit: true,
      modelData: {
        name: '',
        course_id: '',
        chapter_id: '',
        time_video: '',
        time_video_txt: '',
        link_video: '',
        lesson_content: '',
        lesson_document: '',
        time: 15,
        type_time: 1,
        type_question: 1,
        score_success: 6,
        status: true
      },
      configData: {
        course: {
          id: 0,
          name: 'Tên khóa này'
        },
        chapter: {
          id: 0,
          name: 'Tên chương này'
        }
      },
      tinymce: {
        toolbar1: 'undo redo formatselect fontsizeselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent'
      },
      lists: {
        listTypeTime: [
          {key: 1, value: 'Kiểm tra 15 phút'},
          {key: 6, value: 'Kiểm tra kết thúc khóa học kĩ năng'}
        ],
        listTypeQuesition: [
          {key: 1, value: 'Trắc nghiệm'},
          {key: 2, value: 'Tự luận'}
        ],
        listScoreSuccess: [
          {key: 0, value: '0 điểm'},
          {key: 0.5, value: '0,5 điểm'},
          {key: 1, value: '1 điểm'},
          {key: 1.5, value: '1.5 điểm'},
          {key: 2, value: '2 điểm'},
          {key: 2.5, value: '2.5 điểm'},
          {key: 3, value: '3 điểm'},
          {key: 3.5, value: '3.5 điểm'},
          {key: 4, value: '4 điểm'},
          {key: 4.5, value: '4.5 điểm'},
          {key: 5, value: '5 điểm'},
          {key: 5.5, value: '5.5 điểm'},
          {key: 6, value: '6 điểm'},
          {key: 6.5, value: '6.5 điểm'},
          {key: 7, value: '7 điểm'},
          {key: 7.5, value: '7.5 điểm'},
          {key: 8, value: '8 điểm'},
          {key: 8.5, value: '8.5 điểm'},
          {key: 9, value: '9 điểm'},
          {key: 9.5, value: '9.5 điểm'},
          {key: 10, value: '10 điểm'}
        ]
      },
      rules: {
        name: [
          { required: true, message: 'Vui lòng nhập tên đề thi' },
          { min: 2, max: 191, message: 'Tên bài học có chiều dài từ 2 tới 191 kí tự' }
        ],
        time: [
          { required: true, message: 'Vui lòng nhập thời gian thi' }
        ]
      }
    }
  },
  mounted () {
    // this.$refs.myInput.focus()
    this.configDataAndBreadcrumb()
    this.fetchModel()
  },
  methods: {
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình dữ liệu về khóa học, bài, cấu hình Breadcrumb
    configDataAndBreadcrumb () {
      this.modelData.course_id = this.$route.params.course_id
      this.modelData.chapter_id = this.$route.params.chapter_id
      this.fetchCourse()
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.get('test-kits/' + this.$route.params.test_kit_id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchCourse () {
      axios.get('courses/' + this.$route.params.course_id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.configData.course = response.data
            this.fetchChapter()
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchChapter () {
      axios.get('chapters/' + this.$route.params.chapter_id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.configData.chapter = response.data
            this.modelData.name = 'Kiểm tra 15 phút - Chương: ' + this.configData.chapter.name
            this.configBreadcrumb()
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'courses-index', text: 'Khóa học' },
        { name: 'courses-show', course_id: this.$route.params.course_id, text: this.configData.course.name },
        { name: 'chapters-show', course_id: this.$route.params.course_id, chapter_id: this.$route.params.chapter_id, text: this.configData.chapter.name },
        { name: 'chapters-index', text: 'Cập nhật đề thi' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'chapters-show', params: {course_id: this.$route.params.course_id, chapter_id: this.$route.params.chapter_id}})
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.storeModel()
        } else {
          this.$notify({
            title: 'Lỗi dữ liệu nhập',
            message: 'Vui lòng kiểm tra lại thông tin',
            type: 'warning'
          })
          return false
        }
      })
    },
    storeModel () {
      this.canSubmit = false
      axios.put('test-kits/' + this.$route.params.test_kit_id, this.modelData).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật thành công',
              type: 'success'
            })

            this.$router.push({name: 'chapters-show', params: {course_id: this.$route.params.course_id, chapter_id: this.$route.params.chapter_id}})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  },
  watch: {
    'modelData.type_time': function () {
      let text = ''
      if (this.modelData.type_time === 1) {
        text = 'Kiểm tra 15 phút - Chương: '
      }
      if (this.modelData.type_time === 6) {
        text = 'Kiểm tra kết thúc khóa học kĩ năng - Chương: '
      }
      this.modelData.name = text + this.configData.chapter.name
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/test-results/Update.vue